import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useGetVirtualTourReferenceMeasurements = (tourID: string) => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["virtual-tour-reference-measurements", tourID],
    enabled: !!tourID,
    queryFn: async () => {
      const { data } = await authApi.get<
        Array<VirtualTourReferenceMeasurement>
      >(`/virtual-tour/${tourID}/reference-measurements`);
      return data;
    },
  });

  return result;
};
